<div class="contenedor">
  <h3 class="titulo">{{ infoModal[data.tipo].titulo }}</h3>
  <p [innerHTML]="infoModal[data.tipo].descripcion"></p>
  <button
    mat-raised-button
    color="primary"
    class="white"
    [mat-dialog-close]="true"
    *ngIf="!data?.config?.ocultarBotonPrimario">
    {{ infoModal[data.tipo].botonPrimario }}
  </button>
  <button
    mat-stroked-button
    color="primary"
    class="outline"
    (click)="close()"
    *ngIf="!data?.config?.ocultarBotonSecundario">
    {{ infoModal[data.tipo].botonSecundario }}
  </button>
</div>
